import { render } from "./ClavierView.vue?vue&type=template&id=2ce38469"
import script from "./ClavierView.vue?vue&type=script&lang=js"
export * from "./ClavierView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__